<template>
  <div class="passwordetail">
    <navBack title="缴费管理"></navBack>
    <div class="passwordetail_title">
      <p>缴费管理</p>
    </div>
    <div class="" style="padding: 20px">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="year" label="缴费年度" align="center">
        </el-table-column>
        <el-table-column prop="price" label="金额" align="center">
        </el-table-column>
        <el-table-column prop="startTime" label="生效日期" align="center">
        </el-table-column>
        <el-table-column prop="endTime" label="到期日期" align="center">
        </el-table-column>
        <el-table-column prop="statusLabel" label="审核状态" align="center">
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <!--v-show="scope.row.status_label == '未缴费'" <el-button @click="handleClick(scope.row)" type="text" size="small">下载凭证</el-button> -->
            <el-button
              v-show="scope.row.status == '0' || scope.row.status == '4'"
              @click="resizeUpload(scope.row.code)"
              type="text"
              size="small"
              >上传缴费凭证</el-button
            >
            <el-button
              v-show="scope.row.invoiceImg"
              @click="showPay(scope.row.invoiceImg)"
              type="text"
              size="small"
              >查看票据</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination
      :hide-on-single-page="true"
      style="text-align: center"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
    >
    </el-pagination>
    <uploadPay ref="uploadpay" @refresh="getPayRecord"></uploadPay>
  </div>
</template>

<script>
import { mapState } from "vuex";
import navBack from "../../components/navBack.vue";
import uploadPay from "./components/uploadPay.vue";
import { getPayRecord } from "../../api/moudles/user.js";
export default {
  components: {
    uploadPay,
    navBack,
  },
  data() {
    return {
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      totalNum: 0,
    };
  },
  computed: mapState({
    // 箭头函数可使代码更简练
    userInfo: (state) => state.user.userInfo,
  }),
  created() {
    this.getPayRecord();
  },
  methods: {
    // 查看票据
    showPay(url) {
      window.open(url);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPayRecord();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getPayRecord();
    },
    // 上传缴费凭证
    resizeUpload(row) {
      this.$refs["uploadpay"].openDialog(row);
    },
    // 点击事件
    handleClick(row) {
      console.log(row);
    },
    // 获取缴费记录
    async getPayRecord() {
      await getPayRecord({
        data: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          memberCode: this.userInfo.memberCode,
        },
        success: (res) => {
          console.log("缴费", res);
          this.tableData = res.data.list;
          this.totalNum = parseInt(res.data.total);
        },
      });
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .passwordetail_title {
    display: none;
  }
  .passwordetail {
    min-height: 700px;
    padding-bottom: 60px;
    background-color: #fff;
  }
}

@media screen and (min-width: 750px) {
  .passwordetail_title {
    height: 60px;
    font-weight: 500;
    font-size: 22px;
    line-height: 60px;
    padding-left: 20px;
    border-bottom: 1px solid #f2f2f2;
  }
  .passwordetail {
    min-height: 650px;
    padding-bottom: 20px;
    background-color: #fff;
  }
}
</style>
